/** Swedish labels and badge tones for payment files and rows. */
export const FILE_STATUS = {
  created: { label: 'Skapad, inte uppladdad', tone: 'warning' },
  uploaded: { label: 'Uppladdad', tone: 'info' },
  accepted: { label: 'Godkänd av banken', tone: 'info' },
  partially_accepted: { label: 'Delvis godkänd', tone: 'warning' },
  rejected: { label: 'Avvisad', tone: 'danger' },
  partially_settled: { label: 'Delvis betald', tone: 'info' },
  settled: { label: 'Betald', tone: 'success' },
  cancelled: { label: 'Avbruten', tone: 'muted' },
};

export const ROW_STATUS = {
  queued: { label: 'I kö', tone: 'muted' },
  in_file: { label: 'I betalfil', tone: 'info' },
  pending: { label: 'Väntar hos banken', tone: 'warning' },
  accepted: { label: 'Godkänd', tone: 'info' },
  rejected: { label: 'Avvisad', tone: 'danger' },
  settled: { label: 'Betald', tone: 'success' },
  removed: { label: 'Borttagen', tone: 'muted' },
  cancelled: { label: 'Avbruten', tone: 'muted' },
};

export const CATEGORY = {
  SALA: 'Löner',
  SUPP: 'Leverantörer',
};

export const SOURCE_GROUP = {
  payroll: 'Löner',
  supplier_invoices: 'Leverantörer',
  skatteverket: 'Skatt',
  manual: 'Övrigt',
};

export const EVENT_LABEL = {
  queued: 'Lades i betalningskön',
  removed: 'Togs bort från kön',
  file_created: 'Betalfil skapad',
  downloaded: 'Nedladdad',
  uploaded: 'Markerad som uppladdad',
  cancelled: 'Avbruten',
  retried: 'Nytt försök skapat',
  status_imported: 'Återrapport inläst',
  duplicate_submission_reported: 'Dubbel uppladdning rapporterad',
  contradictory_report: 'Motstridig återrapport',
  payment_registered_outside_file: 'Betalning registrerad utanför filen',
  payment_reversed: 'Betalning återförd',
  settled: 'Betald',
  settlement_undone: 'Bankkoppling ångrad',
};

export const SCHEME_LABEL = { BGNR: 'Bankgiro', PGNR: 'Plusgiro', IBAN: 'IBAN', BBAN: 'Bankkonto' };

export const kr = (amount) =>
  `${Number(amount || 0).toLocaleString('sv-SE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} kr`;
